/* eslint-disable */
import React from 'react'

export default function BoxLegend({
    settings,
    color,
    size,
    maxCount,
    chartOptions = {},
}) {
    let sizes = [maxCount, Math.floor(maxCount / 2), 1]

    if (Math.floor(maxCount / 2) == 1 && maxCount > 1) {
        sizes = [maxCount, 1]
    }
    if (maxCount === 1) {
        sizes = [1]
    }
    const legendType = chartOptions.type

    const translateRightLegend = [
        settings.vizWidth * 0.77,
        settings.vizWidth * 0.75,
    ]
    const translateLeftLegend = [
        settings.vizWidth * 0.05,
        settings.vizWidth * 0.75,
    ]

    if (settings.orientation === 'portrait') {
        translate = [0, settings.vizWidth * 1.05]
    }

    if (color.domain && color.domain().length > 0) {
        let yStart = 0

        const legendNameMultiple = chartOptions.legendName
            ? `${chartOptions.legendName}s`
            : 'Attempts'
        const legendNameOne = chartOptions.legendName
            ? `${chartOptions.legendName}`
            : 'Attempt'

        const legend = []
        legend.push(
            <g
                key="boxLegend"
                id="boxLegend"
                transform={`translate(${translateRightLegend})`}
            >
                {sizes.map((d, i) => {
                    yStart = i
                    return (
                        <g key={`g_${i}`}>
                            <rect
                                id={`rectOuter_${d.id || i}`}
                                key={`outer_${i}`}
                                transform={`translate(0, ${i * 28})`}
                                y={-6}
                                width={size(d)}
                                height={size(d)}
                                fill="none"
                                stroke="#000"
                            />
                            <text
                                key={`boxLegendText_${i}`}
                                className="legend"
                                dy="4"
                                transform={`translate(20, ${i * 28})`}
                                fill="#000"
                                style={{ fontSize: `.8rem` }}
                            >
                                {d}{' '}
                                {d === 1 ? legendNameOne : legendNameMultiple}
                            </text>
                        </g>
                    )
                })}
                );
            </g>
        )

        const oaa = [5, 0, -5]
        legend.push(
            <g
                key="boxLegend"
                id="boxLegend"
                transform={`translate(${translateLeftLegend})`}
            >
                {oaa.map((d, i) => {
                    yStart = i
                    return (
                        <g key={`g_${i}`}>
                            <text
                                key={`boxLegendText_${i}`}
                                className="legend"
                                dy="4"
                                transform={`translate(20, ${i * 28})`}
                                fill={color(d)}
                                style={{ fontSize: `.8rem` }}
                            >
                                {d} OAA
                            </text>
                        </g>
                    )
                })}
            </g>
        )
        return legend
    }
    return null
}
